var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.data
    ? _c("aside", { staticClass: "provider" }, [
        _c(
          "a",
          {
            staticClass: "provider__link",
            attrs: { href: _vm.data.clinicUrl },
          },
          [
            _c("p", { staticClass: "location-name" }, [
              _vm._v(_vm._s(_vm.locationName)),
            ]),
            _vm._v(" "),
            _c("p", { staticClass: "location" }, [
              _vm._v(
                _vm._s(_vm.data.city.toUpperCase()) +
                  ", " +
                  _vm._s(_vm.data.state.toUpperCase())
              ),
            ]),
            _vm._v(" "),
            _c("img", {
              staticClass: "image",
              attrs: { alt: _vm.data.hcpName, src: _vm.data.imageUrl },
            }),
            _vm._v(" "),
            _c("div", { staticClass: "who" }, [
              _c("label", { staticClass: "name" }, [
                _vm._v(_vm._s(_vm.data.hcpName)),
              ]),
              _vm._v(" "),
              _c("label", { staticClass: "title" }, [
                _vm._v("Hearing Care Practitioner"),
              ]),
            ]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "information" },
              [
                _vm.milesAway
                  ? _c("p", { staticClass: "distance" }, [
                      _c("strong", [_vm._v(_vm._s(_vm.milesAway))]),
                      _vm._v(" Miles Away"),
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _vm.nextAvailableAppointment
                  ? [
                      _c("p", { staticClass: "nextAppointment" }, [
                        _vm._v("Next Available Appointment"),
                      ]),
                      _vm._v(" "),
                      _c("p", { staticClass: "appointmentTime" }, [
                        _vm._v(_vm._s(_vm.nextAvailableAppointment)),
                      ]),
                    ]
                  : [
                      _c("p", { staticClass: "nextAppointment" }, [
                        _vm._v(" "),
                      ]),
                      _vm._v(" "),
                      _c("p", { staticClass: "appointmentTime" }, [
                        _vm._v(" "),
                      ]),
                    ],
              ],
              2
            ),
          ]
        ),
        _vm._v(" "),
        _c("div", { staticClass: "footer-actions" }, [
          _c(
            "a",
            {
              staticClass: "btn-beltone dark",
              attrs: {
                href: "tel:" + this.helpers().callCenterPhoneNumber(),
                target: "_top",
              },
            },
            [
              _vm._v(
                "Call " +
                  _vm._s(this.helpers().callCenterPhoneNumber()) +
                  " to Schedule"
              ),
            ]
          ),
          _vm._v(" "),
          _c(
            "button",
            {
              staticClass: "btn-beltone",
              on: {
                click: function ($event) {
                  return _vm.showScheduling(_vm.data.clinicUrl)
                },
              },
            },
            [_vm._v("Book Online")]
          ),
        ]),
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }